import React from 'react'
import block from 'bem-cn'

import { useAppTranslation } from 'shared/hooks/useAppTranslation'

import { useModalContext } from '@bcraft-frontend-lib/core'

import { ModalWrapper } from 'components/ModalWrapper'
import { Button, ButtonSizes } from 'components/UIKit'

import './VerifyEmailSuccessModal.scss'

type VerifyEmailSuccessModalProps = {
  path: string
}

const b = block('verify-email-success')

export const VerifyEmailSuccessModal: React.FC<VerifyEmailSuccessModalProps> = ({ path }) => {
  const { t } = useAppTranslation()
  const { closeModal } = useModalContext()

  const onClose = () => {
    closeModal(path)()
  }

  return (
    <ModalWrapper className={b()} onClose={onClose}>
      <div className={b('text')}>{t('auth.verifyEmailSuccess')}</div>
      <Button fullWidth uppercase text={t('bonuses.ok')} onClick={onClose} size={ButtonSizes.LARGE} />
    </ModalWrapper>
  )
}
